
import { getHeadForPage } from '~/utils'

export default {
  layout: 'dashboard',

  transition: 'fade',

  nuxtI18n: {
    paths: {
      de: '/gesuche/gruppe',
      fr: '/gesuche/gruppe',
      it: '/gesuche/gruppe',
    },
  },

  async asyncData(context) {
    await context.store.dispatch('applicationForms/gruppe/gesuch/reset')
    await context.store.dispatch('applicationForms/gruppe/gesuch/init', context)

    const application =
      context.store.state.applicationForms.einzelperson.gesuch.application

    if (!application.id) {
      return {}
    }

    if (
      application.type !== 'group-application' ||
      application.status !== 'preparing'
    ) {
      context.redirect(`/gesuche#${application.id}`)
    }

    return {}
  },

  data() {
    return {
      // TODO: Data from CMS
      page: {
        title: this.$t('wizard.group-application'),
      },
    }
  },

  head() {
    return this.page ? getHeadForPage(this.page) : {}
  },
}
